import type { ComparisonRow } from '../types/content'

export const vrfbSteps = [
  { title: 'Store', detail: 'Energy is held in liquid electrolyte in two external tanks.' },
  { title: 'Flow', detail: 'Pumps move the electrolyte through a cell stack.' },
  { title: 'Exchange', detail: 'Ions cross a membrane inside the stack, and current flows to your load.' },
]

export const vrfbFits = [
  { title: 'Long-duration storage', detail: 'Energy and power are sized separately, so you can add hours of storage.' },
  { title: 'Frequent cycling', detail: 'Suited to sites that charge and discharge every day.' },
  { title: 'Resilience', detail: 'Stored energy on hand for backup when supply is interrupted.' },
]

// General technology characteristics — not AFB product specifications.
export const comparison: ComparisonRow[] = [
  {
    label: 'How it’s sized',
    vrfb: 'Energy (tanks) and power (stack) sized separately',
    lithium: 'Energy and power sized together, in the cells',
    diesel: 'Fuel on hand sets the runtime',
  },
  {
    label: 'Typical best fit',
    vrfb: 'Long-duration, frequent daily cycling',
    lithium: 'Short-duration, high-power or compact sites',
    diesel: 'On-demand generation and peak loads',
  },
  {
    label: 'Ongoing inputs',
    vrfb: 'Pump and system servicing',
    lithium: 'Thermal management and cell monitoring',
    diesel: 'Fuel deliveries and engine servicing',
  },
]
